import React from 'react';
import { Box, Text } from '@chakra-ui/react';

// A prominent, page-wide strip making it unmistakable that this is a preview
// build — the validator AND the OMC-JSON v3.0 schema it targets are both
// preview releases, so results may change before either stabilizes.
const PreviewBanner: React.FC = () => (
  <Box
    bg="orange.100"
    color="orange.900"
    borderBottom="1px solid"
    borderColor="orange.300"
    padding="10px 5%"
  >
    <Text fontSize="sm">
      <Text as="span" fontWeight="bold">Preview release.</Text>{' '}
      This is a preview build of the OMC Validator, targeting the{' '}
      <Text as="span" fontWeight="bold">preview release of the OMC-JSON v3.0 schema</Text>.
      Rules, results, and behavior may change before the stable release.
    </Text>
  </Box>
);

export default PreviewBanner;
